import Select, { components } from 'react-select';
import React, { useState } from 'react'
import { ValidationError } from '../../../assets/ErrorTypes';


export const useBlsSelect = inputData => {
    const [value, setValue] = useState(inputData.value ?? null)
    const [optionList, setOptionList] = useState(inputData.optionList ?? [])
    const [label, setLabel] = useState(inputData.label ?? "labelAdı")
    const [placeHolder, setPlaceHolder] = useState(inputData.placeHolder)
    const [isLabelHidden, setIsLabelHidden] = useState(inputData.labelHide ?? false)
    const [isHidden, setIsHidden] = useState(inputData.isHidden ?? false)
    const [disabled, setDisabled] = useState(inputData.disabled ?? false)
    const [allowBlank, setAllowBlank] = useState(inputData.allowBlank ?? true)

    const reset = () => {
        setValue(inputData.value ?? null)
        setOptionList(inputData.optionList ?? [])
        setLabel(inputData.label ?? "labelAdı")
        setPlaceHolder(inputData.placeHolder ?? null)
        setIsLabelHidden(inputData.labelHide ?? false)
        setIsHidden(inputData.isHidden ?? false)
        setDisabled(inputData.disabled ?? false)
        setAllowBlank(inputData.allowBlank ?? true)
    }

    const optionLabel = inputData.optionLabel ?? ""
    const optionValue = inputData.optionValue ?? ""

    const clear = () => {
        setValue(null);
    }

    const getOptionList = () => { //Sadece dış kapı ve iç kapı işlemlerinde kullanılır ya da başka formatlı option'larda
        return optionList[0].options
    }

    const checkRequired = () => {
        if (!allowBlank) {
            if (isNullOrEmpty()) {
                throw new ValidationError(`${label.replace(":", "")} alanı zorunludur`)
            }
        }
    }

    const select = query => {
        const result = optionList.find(item => item[optionValue] === (query ? query : ""))
        setValue(result)
    }

    const isNullOrEmpty = () => {
        return (value === null || value === undefined);
    }

    const hide = () => setIsHidden(true);
    const show = () => setIsHidden(false);

    return {
        value, setValue,
        label, setLabel,
        optionList, setOptionList,
        isHidden, setIsHidden,
        isLabelHidden, setIsLabelHidden,
        disabled, setDisabled,
        placeHolder, setPlaceHolder,
        optionLabel, optionValue,
        select, clear,
        isNullOrEmpty,
        allowBlank, setAllowBlank,
        checkRequired, reset,
        getOptionList,
        hide, show
    }
}

const BlsSelect = ({labelStyle, containerStyle, inputContainerStyle, inputState, onChange = () => { }, onBlur = () => { }, forRow = false, labelAlign = 'left', maxMenuHeight = 250, menuPlacement = 'bottom', isClearable = false}) => {
    const isValid = inputState.allowBlank ? true : !inputState.isNullOrEmpty();
    const clearSelectedValue = () => {
        inputState.setValue(null)
        onChange(null)
    }
    return (
        forRow
            ? <div style={{
                boxShadow: '1px 1px 5px #aeaeae',
                borderWidth: '1px',
                borderColor: '#f0f0f0',
                borderRadius: 3,
                width: inputState.isLabelHidden ? '100%' : labelAlign === 'left' ? '50%' : '100%',
                height: '20px',
                float: "left",
                textAlign: "left",
                display: inputState.isHidden ? 'none' : 'block',
                ...containerStyle
            }}>
                <Select
                    value={inputState.value}
                    options={inputState.optionList}
                    placeholder={inputState.disabled ? "" : inputState.placeHolder ?? `${inputState.label.replace(":", "")} Seçiniz...`}
                    getOptionLabel={(option) => typeof (inputState.optionLabel) === "string" ? option[inputState.optionLabel] : inputState.optionLabel(option)}
                    getOptionValue={(option) => typeof (inputState.optionValue) === "string" ? option[inputState.optionValue] : inputState.optionValue(option)}
                    menuPlacement={menuPlacement}
                    onChange={value => {
                        inputState.setValue(value);
                        onChange(value)
                    }}
                    onBlur={onBlur}
                    isDisabled={inputState.disabled}
                    isClearable={isClearable}
                    isSearchable={true}
                    name="color"
                    components={{
                        ...components,
                        DropdownIndicator: (props) => inputState.disabled ? null : components.DropdownIndicator(props),
                        ClearIndicator: () => isClearable ? <div style={{padding: '0px', cursor: 'pointer', color: 'red', fontWeight: 'bold'}} onClick={clearSelectedValue}>X</div> : null,
                    }}
                    noOptionsMessage={() => null}
                    styles={{
                        control: (provided, state) => ({
                            ...provided,
                            background: '#fff',
                            minHeight: '20px',
                            height: '20px',
                            borderColor: '#f0f0f0',
                            borderWidth: '1px',
                            boxShadow: state.isFocused ? '1px 1px 5px #aeaeae' : '1px 1px 5px #aeaeae',
                            fontSize: '12px',
                            width: "100%",
                            marginLeft: "0%",
                            color: '#000',
                            border: (inputState.disabled || isValid) ? 'none' : '1px solid red'
                        }),

                        valueContainer: provided => ({...provided, height: '20px', padding: '0 1px', fontSize: '12px', color: '#000', fontWeight: '400', fontFamily: 'Arial',}),

                        singleValue: provided => ({...provided, color: '#000'}),

                        input: provided => ({...provided, margin: '0px', fontWeight: 'bold', fontSize: '12px', color: '#000'}),

                        indicatorSeparator: () => ({display: 'none'}),

                        indicatorsContainer: provided => ({...provided, height: '20px'}),

                        placeholder: styles => ({...styles, fontSize: "0.6vw", display: "inline-block", float: "left", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden"}),

                        option: (styles) => ({...styles, color: '#000', fontSize: '12px', textAlign: 'left', fontWeight: 'bold'}),

                        groupHeading: base => ({
                            ...base,
                            top: '-4px',
                            position: 'sticky',
                            backgroundColor: "#C0392B",
                            color: '#fff',
                            padding: "5px 5px 5px 10px",
                            marginTop: '-10px',
                            textTransform: 'none',
                            textAlign: 'left',
                        })
                    }}
                    maxMenuHeight={maxMenuHeight}
                />
            </div>
            : <div style={{
                marginTop: '1%',
                borderWidth: 0,
                border: 'none',
                width: '100%',
                flexDirection: labelAlign === 'left' ? 'row' : 'column',
                display: inputState.isHidden ? 'none' : 'flex',
                ...containerStyle
            }}>
                <label
                    className='dark:text-white text-black'
                    style={{
                        borderWidth: '1px',
                        borderColor: '#f0f0f0',
                        borderRadius: 3,
                        width: labelAlign === 'left' ? '38%' : '100%',
                        height: '20px',
                        float: "left",
                        paddingLeft: labelAlign === 'left' ? "2%" : "0%",
                        textAlign: "left",
                        backgroundColor: "transparent",
                        overflow: "hidden",
                        fontSize: '.73rem',
                        display: inputState.isLabelHidden ? 'none' : 'block',
                        ...labelStyle
                    }}>{inputState.label}</label>

                <div style={{
                    boxShadow: '1px 1px 5px #aeaeae',
                    borderWidth: '1px',
                    borderRadius: 3,
                    width: inputState.isLabelHidden ? '100%' : labelAlign === 'left' ? '50%' : '100%',
                    height: '20px',
                    float: "left",
                    textAlign: "left",
                    borderColor: inputState.allowBlank ? 'red' : 'tranparent',
                    ...inputContainerStyle
                }}>
                    <Select
                        value={inputState.value}
                        options={inputState.optionList}
                        placeholder={inputState.disabled ? "" : inputState.placeHolder ?? `${inputState.label.replace(":", "")} Seçiniz...`}
                        getOptionLabel={(option) => typeof (inputState.optionLabel) === "string" ? option[inputState.optionLabel] : inputState.optionLabel(option)}
                        getOptionValue={(option) => option[inputState.optionValue]}
                        menuPlacement={menuPlacement}
                        onChange={value => {
                            inputState.setValue(value);
                            onChange(value)
                        }}
                        onBlur={onBlur}
                        isDisabled={inputState.disabled}
                        isClearable={isClearable}
                        isSearchable={true}
                        name="color"
                        components={{
                            ...components,
                            DropdownIndicator: (props) => inputState.disabled ? null : components.DropdownIndicator(props),
                            ClearIndicator: () => isClearable ? <div style={{padding: '0px', cursor: 'pointer', color: 'red', fontWeight: 'bold'}} onClick={clearSelectedValue}>X</div> : null,
                        }}
                        noOptionsMessage={() => null}
                        styles={{
                            control: (provided, state) => ({
                                ...provided,
                                background: '#fff',
                                minHeight: '20px',
                                height: '20px',
                                borderColor: '#f0f0f0',
                                borderWidth: '1px',
                                boxShadow: state.isFocused ? '1px 1px 5px #aeaeae' : '1px 1px 5px #aeaeae',
                                fontSize: '12px',
                                width: "100%",
                                marginLeft: "0%",
                                color: '#000',
                                border: (inputState.disabled || isValid) ? 'none' : '1px solid red'
                            }),

                            valueContainer: provided => ({...provided, height: '20px', padding: '0 1px', fontSize: '12px', color: '#000', fontWeight: '400', fontFamily: 'Arial',}),

                            singleValue: provided => ({...provided, color: '#000'}),

                            input: provided => ({...provided, margin: '0px', fontWeight: 'bold', fontSize: '12px', color: '#000'}),

                            indicatorSeparator: () => ({display: 'none'}),

                            indicatorsContainer: provided => ({...provided, height: '20px'}),

                            placeholder: styles => ({...styles, fontSize: "0.6vw", display: "inline-block", float: "left", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden"}),

                            option: (styles) => ({...styles, color: '#000', fontSize: '12px', textAlign: 'left', fontWeight: 'bold'}),

                            groupHeading: base => ({
                                ...base,
                                top: '-4px',
                                position: 'sticky',
                                backgroundColor: "#C0392B",
                                color: '#fff',
                                padding: "5px 5px 5px 10px",
                                marginTop: '-10px',
                                textTransform: 'none',
                                textAlign: 'left',
                            })
                        }}
                        maxMenuHeight={maxMenuHeight}
                    />
                </div>
            </div>

    );
}

export default BlsSelect